import { Integration, MobileApp, TestPushPayload } from 'modules/mobileApps/types';
import { ApiResponse, getRaw, postFormRaw, postRaw } from 'services/api';

export const CREATE_INTEGRATION_URL = '/integrations/createPushIntegration';
export const CREATE_MOBILE_APP_URL = '/integrations/createMobileApp';
export const DELETE_INTEGRATION_URL = '/integrations/deletePushIntegration';
export const DELETE_MOBILE_APP_URL = '/integrations/deleteMobileApp';
export const GET_INTEGRATIONS_URL = '/integrations/mobilePush.json';
export const MOBILE_APPS_URL = '/integrations/mobileApps.json';
export const MOBILE_APP_INFO_URL = '/integrations/mobileAppInfo';
export const TEST_PUSH_URL = '/integrations/sendPushNotification';
export const UPDATE_INTEGRATION_URL = '/integrations/updatePushIntegration';
export const UPDATE_MOBILE_APP_URL = '/integrations/updateMobileApp';

/**
 * POST endpoint for creating a new mobile app
 * @param {MobileApp} app
 */
export const createMobileApp = (app: MobileApp): Promise<ApiResponse> =>
  postRaw(CREATE_MOBILE_APP_URL, app);

/**
 * POST endpoint for deleting a mobile app
 * @param {MobileApp} app
 */
export const deleteMobileApp = (app: MobileApp): Promise<ApiResponse> =>
  postRaw(DELETE_MOBILE_APP_URL, { id: app.id });

/**
 * GET endpoint for fetching integrations
 */
export const getIntegrations = (): Promise<ApiResponse> => getRaw(GET_INTEGRATIONS_URL);

/**
 * GET endpoint for fetching mobile app details
 * @param {number} appId
 */
export const getMobileAppInfo = (appId: number): Promise<ApiResponse> =>
  getRaw(`${MOBILE_APP_INFO_URL}/${appId}`);

/**
 * GET endpoint for fetching mobile apps
 */
export const getMobileApps = (): Promise<ApiResponse> => getRaw(MOBILE_APPS_URL);

/**
 * POST endpoint for initiating a test push
 * @param deviceToken
 * @param message
 * @param pushConfig
 */
export const sendTestPush = (pushMessage: TestPushPayload) => postRaw(TEST_PUSH_URL, pushMessage);

/**
 * POST endpoint for initiating a test push
 * @param app
 */
export const updateMobileApp = (app: MobileApp): Promise<ApiResponse> =>
  postRaw(UPDATE_MOBILE_APP_URL, app);

/**
 * POST endpoint for creating a new integration
 * @param integration
 */
export const createIntegration = (integration: Integration): Promise<ApiResponse> =>
  postFormRaw(CREATE_INTEGRATION_URL, integration);

/**
 * POST endpoint for updating an existing integration
 * @param integration
 */
export const updateIntegration = (integration: Integration): Promise<ApiResponse> =>
  postFormRaw(UPDATE_INTEGRATION_URL, integration);

/**
 * POST endpoint for deleting an integration
 * @param integration
 */
export const deleteIntegration = (integration: Integration): Promise<ApiResponse> =>
  postRaw(DELETE_INTEGRATION_URL, {
    platform: integration.platform,
    name: integration.name,
  });
